import { dateISOToMMMddyyyy } from 'Data/format.js'

export function getDate(value) {
  return (value && `on ${dateISOToMMMddyyyy(value)}`) || '-'
}

export function getLog(value) {
  if (!value?.metadata?.title && value.textParts) {
    return buildSentence(value.textParts)
  } else if (value?.metadata?.title) {
    return `${value?.metadata?.title} ${
      value?.metadata?.message?.charAt(0).toLowerCase() +
      value?.metadata?.message?.slice(1).replace(/\.$/, '')
    } ${getDate(value.created_at)}.`
  }

  return null
}

export function buildSentence({ actor, verb, target, from, to, noTo, on }) {
  let parts = []

  if (actor) parts.push(actor)
  if (verb) parts.push(verb)
  if (target) parts.push(`the ${target}`)

  if (from) parts.push(`from ${from}`)

  if (to) {
    if (noTo) {
      parts.push(to) // just the value
    } else {
      parts.push(`to ${to}`) // normal "to ..."
    }
  }

  if (on) parts.push(`on ${on}`)

  return parts.join(' ') + '.'
}
